import request from "@/utils/request";

export default function remove(id) {
    return request({
        url: `/storeShop/admin/remove/`+id,
        method: 'get',
    })
}
